/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();

      const slideshow = this,
        dataset = slideshow.dataset;

      let dots = dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade == 'true',
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        custom_dots = slideshow.querySelector('.flickity-page-dots'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      if (slideshow_slides.length < 1) return;

      const isMobile = window.matchMedia("(max-width: 749px)").matches;

      const args = {
        wrapAround: true,
        cellAlign: align,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        fade: fade,
        rightToLeft: rightToLeft,
        cellSelector: '.carousel__slide',
        autoPlay: autoplay,
        on: {}
      };
if (isMobile && slideshow.closest('.section-collection-tabs')) {
  args.wrapAround = false;
  args.draggable = true;
  args.selectedAttraction = 0.035;
  args.friction = 0.22;
  args.freeScroll = false;
  args.percentPosition = false;
}




      if (!isMobile) {
  args.wrapAround = false;
  args.cellAlign = 'left';
  args.contain = true;
  args.percentPosition = false;
}
      if (slideshow.classList.contains('image-with-text-slideshow__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }

      if (slideshow.classList.contains('customer-reviews__image')) {
        let main_slideshow = slideshow.parentNode.querySelector('.customer-reviews__content');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }

      if (
        slideshow.classList.contains('image-with-text-slideshow__content') ||
        slideshow.classList.contains('testimonials__carousel') ||
        slideshow.classList.contains('customer-reviews__content') ||
        slideshow.classList.contains('customer-reviews__image')
      ) {
        args.adaptiveHeight = true;
      }

      if (slideshow.classList.contains('custom-dots')) {
        args.pauseAutoPlayOnHover = false;

        args.on = {
          ready: function () {
            let flkty = this;

            if (dots && custom_dots) {
              let dotsEl = custom_dots.querySelectorAll('li');

              dotsEl.forEach((dot, i) => {
                dot.addEventListener('click', () => flkty.select(i));
              });

              dotsEl[this.selectedIndex].classList.add('is-selected');
            }

            slideshow.playAllVideos();
          },

          change: function () {
            let flkty = this;

            if (dots && custom_dots) {
              let dotsEl = custom_dots.querySelectorAll('li');

              dotsEl.forEach(dot => dot.classList.remove('is-selected'));
              dotsEl[this.selectedIndex].classList.add('is-selected');
            }
          }
        };
      }

      if (progress_bar) {
        args.on.scroll = function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + '%';
        };
      }

      let flkty = new Flickity(slideshow, args);
      // const flkty = new Flickity(slideshow, args);
slideshow.dataset.initiated = true;

setTimeout(() => {
  flkty.reloadCells();
  flkty.resize();
  flkty.reposition();
}, 300);

// let isMobileLayout = window.matchMedia("(max-width: 749px)").matches;
// let resizeTimer;

// window.addEventListener('resize', () => {
//   clearTimeout(resizeTimer);

//   resizeTimer = setTimeout(() => {
//     const currentMobileState = window.matchMedia("(max-width: 749px)").matches;

//     if (currentMobileState !== isMobileLayout) {
//       isMobileLayout = currentMobileState;
      
//       if (typeof flkty.destroy === 'function') {
//         flkty.destroy();
//       }
      
//       if (!isMobileLayout) {
//         args.wrapAround = false;
//         args.cellAlign = 'left';
//         args.contain = true;
//         args.percentPosition = false;
      // } else {
      //   args.wrapAround = true;
      //   args.cellAlign = dataset.align == 'center' ? 'center' : 'left';
      //   args.contain = true;
      //   args.percentPosition = true;
      // }




// } else {
//   args.wrapAround = true;
//   args.cellAlign = dataset.align == 'center' ? 'center' : 'left';
//   args.contain = true;
//   args.percentPosition = true;

//   if (slideshow.closest('.section-collection-tabs')) {
//     args.wrapAround = false;
//     args.draggable = true;
//     args.selectedAttraction = 0.035;
//     args.friction = 0.22;
//     args.freeScroll = false;
//     args.percentPosition = false;
//   }
// }


      
//       flkty = new Flickity(slideshow, args);
//     } else {
//       flkty.reloadCells();
//       flkty.resize();
//       flkty.reposition();
//     }

//     if (window.innerWidth >= 750) {
//       flkty.select(0, false, true);
//     }
//   }, 250);
// });




let isMobileLayout = window.matchMedia("(max-width: 749px)").matches;
let resizeTimer;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);

  resizeTimer = setTimeout(() => {
    const currentMobileState = window.matchMedia("(max-width: 749px)").matches;

    // Only rebuild when crossing mobile/desktop breakpoint
    if (currentMobileState !== isMobileLayout) {
      isMobileLayout = currentMobileState;

      if (typeof flkty.destroy === 'function') {
        flkty.destroy();
      }

      if (!isMobileLayout) {
        args.wrapAround = false;
        args.cellAlign = 'left';
        args.contain = true;
        args.percentPosition = false;
      } else {
        args.wrapAround = true;
        args.cellAlign = dataset.align == 'center' ? 'center' : 'left';
        args.contain = true;
        args.percentPosition = true;

        if (slideshow.closest('.section-collection-tabs')) {
          args.wrapAround = false;
          args.draggable = true;
          args.selectedAttraction = 0.035;
          args.friction = 0.22;
          args.freeScroll = false;
          args.percentPosition = false;
        }
      }

      flkty = new Flickity(slideshow, args);

      if (!isMobileLayout) {
        flkty.select(0, false, true);
      }
    }
  }, 250);
});



















      if (prev_button && next_button) {
        prev_button.addEventListener('click', () => flkty.previous());
        next_button.addEventListener('click', () => flkty.next());
      }

      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }
    }

    playAllVideos() {
      const videos = this.querySelectorAll('.slideshow__slide-video-bg');

      videos.forEach((container) => {
        const video = container.querySelector('video');
        const iframe = container.querySelector('iframe');

        if (video) {
          video.play().catch(() => {});
        }

        if (iframe) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        }
      });
    }
  }

  customElements.define('slide-show', SlideShow);
}